"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Complete = void 0;
var react_1 = __importDefault(require("react"));
var button_1 = require("@chakra-ui/button");
var layout_1 = require("@chakra-ui/layout");
var image_1 = require("@chakra-ui/image");
var layout_2 = require("../../../common/layout");
var PageLoading_1 = require("../../../common/loading/PageLoading");
var useSetMeta_1 = require("../../../common/hooks/useSetMeta");
var useShop_1 = require("../../../common/hooks/useShop");
var Complete = function () {
    var _a = (0, useShop_1.useShop)(), shopData = _a.shopData, isShopLoading = _a.isShopLoading;
    (0, useSetMeta_1.useSetMeta)("プレゼント応募完了");
    if (isShopLoading)
        return react_1.default.createElement(PageLoading_1.PageLoading, null);
    return (react_1.default.createElement(react_1.default.Fragment, null, shopData && (react_1.default.createElement(layout_2.Layout, { headerUrl: shopData.logo_image, isHeader: true, isFooter: true },
        react_1.default.createElement(layout_1.Container, { maxW: "container.xl", textAlign: "center", py: "2em" },
            react_1.default.createElement(layout_1.Text, { as: "h2", fontSize: { base: "2.4rem", md: "3.4rem" }, fontWeight: "bold" }, "\u30D7\u30EC\u30BC\u30F3\u30C8\u5FDC\u52DF"),
            react_1.default.createElement(layout_1.Text, { mt: "1rem", fontSize: "1.6rem" }, "\u3054\u5FDC\u52DF\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\u3002"),
            react_1.default.createElement(image_1.Image, { mt: "1rem", src: "/img/ja/line/line-img04.jpg", mx: "auto" }),
            react_1.default.createElement(layout_1.Box, { mt: "3rem" },
                react_1.default.createElement(button_1.Button, { as: "a", href: "/main", color: "white", bg: "#F9B812", size: "lg", height: "4rem", fontSize: "1.6rem", minW: "10rem", _hover: {
                        color: "white",
                        backgroundColor: "#D59D0F",
                        textDecoration: "none",
                    }, _active: {
                        color: "white",
                        backgroundColor: "#BF8D0D",
                    } }, "\u30C8\u30C3\u30D7\u30DA\u30FC\u30B8\u306B\u623B\u308B")))))));
};
exports.Complete = Complete;
